import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericInput } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';


const BusinessIdInput: InputWithoutSource = ({ input }) => <GenericInput label={input.name} input={input} />;

BusinessIdInput.meta = {
    inputType: InputModel.name
};

export default observer(BusinessIdInput);
